import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateJobFlag } from "../redux/feature/jobSlice";
import {
  DeleteJobConfig,
  GetjobConfigByID,
  GetjobConfiguration,
  jobConfiguration,
  updateJobConfig,
} from "../service/jobconfigApi";
import Swal from "sweetalert2";
import { currentUser } from "../helpers";
import { useSidebar } from "../contexts/sidebarContext";
export default function JobConfiguration() {
  const { getConfiguration: refreshJobConfigSidebar } = useSidebar();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const { state } = location;
  const [jobConfgs, setJobConfigs] = useState({});
  const userInfo = currentUser();
  const userID = userInfo?.userId;
  const ParentID = userInfo?.createdBy;
  const userRole = userInfo?.userRole;
  // eslint-disable-next-line no-unused-vars
  const { id } = useParams();

  const initialValues = {
    sheetName: "",
    // description: "",
    variableCost: "",
    amount: "",
    overheadCosts: "",
    ownersPay: "",
    loans: "",
    other: "",
    companyAdminId:
      userRole === "CompanyAdmin"
        ? userID
        : userRole === "CompanyManager"
        ? ParentID
        : "",
    totalAmount: "",
    highPaid: "",
    highPaidburden: "",
    midPaid: "",
    midPaidburden: "",
    lowPaid: "",
    lowPaidburden: "",
    breakevenHighPaid: "",
    monthlyHighPaid: "",
    breakevenMidPaid: "",
    monthlyMidPaid: "",
    breakevenLowPaid: "",
    monthlyLowPaid: "",
    id: null,
  };

  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState(initialValues);
  const {
    sheetName,
    // description,
    // variableCost,
    // amount,
    // overheadCosts,
    // ownersPay,
    // loans,
    // other,
    // totalAmount,
    highPaid,
    highPaidburden,
    midPaid,
    midPaidburden,
    lowPaid,
    lowPaidburden,
    breakevenHighPaid,
    monthlyHighPaid,
    breakevenMidPaid,
    monthlyMidPaid,
    breakevenLowPaid,
    monthlyLowPaid,
  } = formValues;
  const [variableCost, setVariableCost] = useState(" ");
  const [amount, setAmount] = useState(0);
  const [overheadCosts, setOverheadCosts] = useState(0);
  const [ownersPay, setOwnersPay] = useState(0);
  const [loans, setLoans] = useState(0);
  const [other, setOther] = useState(0);

  // const totalAmount = (amount * variableCost) / 100;
  // const totalAmount =
  //   ((Number(amount) * Number(variableCost)) / 100) +
  //   Number(overheadCosts) +
  //   Number(ownersPay) +
  //   Number(loans) +
  //   Number(other);

  // const totalAmount =
  //   (Number(amount.trimA()) *
  //     Number(variableCost.trimA())) /
  //     100 +
  //   Number(overheadCosts.trimA()) +
  //   Number(ownersPay.replace(/,/g, "")) +
  //   Number(loans.replace(/,/g, "")) +
  //   Number(other.replace(/,/g, ""));
  function trimA(str) {
    return str.toString().replace(/,/g, "");
  }
  const totalAmount =
    (Number(trimA(amount)) * Number(trimA(variableCost))) / 100 +
    Number(trimA(overheadCosts)) +
    Number(trimA(ownersPay)) +
    Number(trimA(loans)) +
    Number(trimA(other));

  useEffect(() => {
    if (totalAmount > 0) {
      setErrors((prevErrors) => ({ ...prevErrors, totalAmount: false }));
    }
  }, [totalAmount]);
  const getConfiguration = async (id) => {
    const response = await GetjobConfigByID(id);

    if (response?.data) {
      setJobConfigs(response?.data[0]);
      let responseData = response.data[0];
      setFormValues({
        id: responseData.id,
        sheetName: responseData.jobConfigName,
        // description: responseData.jobConfigDescription,
        // variableCost: responseData.monthlyVariableCost,
        // amount: responseData.amount,
        // overheadCosts: responseData.overheadCostMonthlyHours,
        // ownersPay: responseData.ownersPayMonthlyHours,
        // loans: responseData.loansMonthlyHours,
        // other: responseData.others,
        totalAmount: responseData.totalAmount,
        highPaid: responseData.laborCostHigh.dollarPerhour,
        highPaidburden: responseData.laborCostHigh.laborBurden,
        midPaid: responseData.laborCostMid.dollarPerhour,
        midPaidburden: responseData.laborCostMid.laborBurden,
        lowPaid: responseData.laborCostLow.dollarPerhour,
        lowPaidburden: responseData.laborCostLow.laborBurden,
        breakevenHighPaid: responseData.breakEvenHigh.averageMonthlyHours,
        monthlyHighPaid: responseData.breakEvenHigh.numberOfPeople,
        breakevenMidPaid: responseData.breakEvenMid.averageMonthlyHours,
        monthlyMidPaid: responseData.breakEvenMid.numberOfPeople,
        breakevenLowPaid: responseData.breakEvenLow.averageMonthlyHours,
        monthlyLowPaid: responseData.breakEvenLow.numberOfPeople,
      });
      setVariableCost(responseData.monthlyVariableCost);
      setAmount(formatNumberWithCommas(responseData.amount || 0));
      setOverheadCosts(
        formatNumberWithCommas(responseData.overheadCostMonthlyHours)
      );
      setOwnersPay(formatNumberWithCommas(responseData.ownersPayMonthlyHours));
      setLoans(formatNumberWithCommas(responseData.loansMonthlyHours));
      setOther(formatNumberWithCommas(responseData.others || 0));
    }
  };

  useEffect(() => {
    if (id) {
      getConfiguration(id);
    } else {
      setFormValues(initialValues);
      setJobConfigs({});
      setVariableCost("");
      setAmount("");
      setOverheadCosts("");
      setOwnersPay("");
      setLoans("");
      setOther("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({
      ...formValues,
      [name]: value,
    });

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
    }
  };
  const formatNumberWithCommas = (value) => {
    // const numericValue = value.replace(/[^0-9]/g, "");
    // return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const numericValue = String(value).replace(/[^0-9]/g, "");
    // Format with commas
    return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const handleVariableCostChange = (e) => {
    const value = e.target.value;
    if (value === "" || !isNaN(value)) {
      setVariableCost(value === "" ? "" : Number(value));
      setErrors((prevErrors) => ({ ...prevErrors, [e.target.name]: false }));
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    // if (value === "" || !isNaN(value)) {
    //   setAmount(value === "" ? "" : Number(value));
    // }

    const formattedValue = formatNumberWithCommas(value);
    setAmount(formattedValue);
    setErrors((prevErrors) => ({ ...prevErrors, [e.target.name]: false }));
  };

  const handleOverheadCostsChange = (e) => {
    const value = e.target.value;
    // if (value === "" || !isNaN(value)) {
    //   setOverheadCosts(value === "" ? "" : Number(value));
    // }
    const formattedValue = formatNumberWithCommas(value);
    setOverheadCosts(formattedValue);
  };

  const handleOwnersPayChange = (e) => {
    const value = e.target.value;
    // if (value === "" || !isNaN(value)) {
    //   setOwnersPay(value === "" ? "" : Number(value));
    // }
    const formattedValue = formatNumberWithCommas(value);
    setOwnersPay(formattedValue);
  };

  const handleLoansChange = (e) => {
    const value = e.target.value;
    // if (value === "" || !isNaN(value)) {
    //   setLoans(value === "" ? "" : Number(value));
    // }
    const formattedValue = formatNumberWithCommas(value);
    setLoans(formattedValue);
  };

  const handleOtherChange = (e) => {
    const value = e.target.value;
    // if (value === "" || !isNaN(value)) {
    //   setOther(value === "" ? "" : Number(value));
    // }
    const formattedValue = formatNumberWithCommas(value);
    setOther(formattedValue);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!sheetName) {
      newErrors.sheetName = "Enter sheet name";
    }
    // if (!description) {
    //   newErrors.description = "Enter description";
    // }
    if (variableCost === "") {
      newErrors.variableCost = "Enter direct cost";
    }
    if (amount === "") {
      newErrors.amount = "Enter Amount ";
    }
    // if (!overheadCosts) {
    //   newErrors.overheadCosts = "Enter overhead costs";
    // }
    // if (!ownersPay) {
    //   newErrors.ownersPay = "Enter owner's pay";
    // }
    // if (!loans) {
    //   newErrors.loans = "Enter loans amount";
    // }
    // if (!other) {
    //   newErrors.other = "Enter other costs";
    // }
    if (totalAmount === "") {
      newErrors.totalAmount = "Enter total of all expenses";
    }

    if (highPaid === "") {
      newErrors.highPaid = "Enter high paid per hour";
    }
    if (highPaidburden === "") {
      newErrors.highPaidburden = "Enter high paid labor burden";
    }
    if (midPaid === "") {
      newErrors.midPaid = "Enter mid paid per dollar";
    }
    if (midPaidburden === "") {
      newErrors.midPaidburden = "Enter mid paid labor burden";
    }
    if (lowPaid === "") {
      newErrors.lowPaid = "Enter low paid per dollar";
    }
    if (lowPaidburden === "") {
      newErrors.lowPaidburden = "Enter low paid labor burden";
    }
    if (breakevenHighPaid === "") {
      newErrors.breakevenHighPaid = "Enter high paid hour month";
    }
    if (monthlyHighPaid === "") {
      newErrors.monthlyHighPaid = "Enter high paid people";
    }

    if (breakevenMidPaid === "") {
      newErrors.breakevenMidPaid = "Enter mid paid hour month";
    }
    if (monthlyMidPaid === "") {
      newErrors.monthlyMidPaid = "Enter mid paid people";
    }
    if (breakevenLowPaid === "") {
      newErrors.breakevenLowPaid = "Enter low paid hour month";
    }
    if (monthlyLowPaid === "") {
      newErrors.monthlyLowPaid = "Enter low paid people";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const HandleJobconfiguration = async () => {
    if (jobConfgs && jobConfgs.id) {
      const { isConfirmed } = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (isConfirmed) {
        const result = await DeleteJobConfig(jobConfgs.id);
        if (result) {
          dispatch(updateJobFlag());

          // await GetjobConfiguration();

          Swal.fire(
            "Deleted!",
            "Job configuration deleted successfully!",
            "success"
          );
          navigate("/JobConfiguration");
          refreshJobConfigSidebar();
        } else {
          Swal.fire("Error!", "Failed to delete job configuration.", "error");
        }
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (validateForm()) {
        // setFormValues(initialValues);
        const payload = {
          jobConfigName: sheetName,
          // jobConfigDescription: description,
          jobConfigDescription: " ",

          monthlyVariableCost: variableCost,
          amount: trimA(amount),
          overheadCostMonthlyHours: overheadCosts.length
            ? trimA(overheadCosts)
            : 0,
          ownersPayMonthlyHours: ownersPay.length ? trimA(ownersPay) : 0,
          loansMonthlyHours: loans.length ? trimA(loans) : 0,
          others: other.length ? trimA(other) : 0,
          companyAdminId:
            userRole === "CompanyAdmin"
              ? userID
              : userRole === "CompanyManager"
              ? ParentID
              : "",
          totalAmount: totalAmount,
          laborCostHigh: {
            dollarPerhour: highPaid,
            laborBurden: highPaidburden,
          },
          laborCostMid: {
            dollarPerhour: midPaid,
            laborBurden: Number(midPaidburden),
          },
          laborCostLow: {
            dollarPerhour: Number(lowPaid),
            laborBurden: lowPaidburden,
          },
          breakEvenHigh: {
            averageMonthlyHours: breakevenHighPaid,
            numberOfPeople: monthlyHighPaid,
          },
          breakEvenMid: {
            averageMonthlyHours: breakevenMidPaid,
            numberOfPeople: monthlyMidPaid,
          },
          breakEvenLow: {
            averageMonthlyHours: breakevenLowPaid,
            numberOfPeople: monthlyLowPaid,
          },
        };
        let response = null;

        if (formValues.id) {
          payload.id = formValues.id;
          response = await updateJobConfig(payload);
          refreshJobConfigSidebar();
          toast.success("Job configuration is successfully Updated!");
        } else {
          response = await jobConfiguration(payload);
          refreshJobConfigSidebar();
          toast.success("Job configuration is successfully Created!");
        }

        if (response) {
          dispatch(updateJobFlag());
          if (!id) {
            setFormValues(initialValues);
            navigate("/jobConfiguration");
            setVariableCost("");
            setOverheadCosts("");
            setAmount("");
            setOwnersPay("");
            setLoans("");
            setOther("");
          }
        } else {
          toast.error("Something Went Wrong!");
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(
        "An error occurred while submitting the form. Please try again."
      );
    }
  };

  return (
    <Container fluid className="p-0 my-3 createJobSection">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex gap-2">
          <Breadcrumb>
            <Breadcrumb.Item>Job Configuration</Breadcrumb.Item>
            <Breadcrumb.Item className="CurrentClass">
              {jobConfgs.id
                ? jobConfgs.jobConfigName
                : "Job Configuration Form"}{" "}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="info_icon">
            <div className="tooltip">
              <FontAwesomeIcon icon={faCircleInfo} />
              <span className="tooltiptext tooltip_text">
                It is strongly suggested to up date this info either monthly or
                yearly to keep the most accurate estimates and break evens
                possible. All figures are base off a trailing 12 month 1 year.
              </span>
            </div>
          </div>
        </div>
        <div>
          {jobConfgs.id ? (
            <Button
              className="btn custom-btn1 mb-3 "
              onClick={HandleJobconfiguration}
            >
              <FontAwesomeIcon icon={faTrash} className="me-1" />
              Delete
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>

      <Form onSubmit={handleSubmit}>
        {/* <Form contentEditable onSubmit={handleSubmit}> */}
        {/* General Info */}
        <Row className="">
          <Col md={6}>
            <h5 className="mb-3">General Info</h5>
            <Card className="border-0 p-3 rounded mb-3 card_general_info">
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3" controlId="sheetName">
                    <Form.Label>
                      Enter Sheet Name<span className="require-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="sheetName"
                      value={sheetName}
                      onChange={handleChange}
                      className={errors.sheetName ? "border-danger" : ""}
                      placeholder="Enter Sheet Name"
                    />
                    {errors.sheetName && (
                      <Form.Text className="text-danger">
                        {errors.sheetName}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                {/* <Col md={6}>
                  <Form.Group className="mb-3" controlId="description">
                    <Form.Label>
                      Description<span className="require-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={description}
                      onChange={handleChange}
                      className={errors.description ? "border-danger" : ""}
                      placeholder="Description"
                    />
                    {errors.description && (
                      <Form.Text className="text-danger">
                        {errors.description}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col> */}
              </Row>
            </Card>
          </Col>
          <Col md={3}>
            <h5 className="mb-3">Yearly Direct Cost (%)</h5>
            <Card className="border-0 p-3 rounded">
              <Form.Group className="" controlId="variableCost">
                <div className="d-flex align-items-center">
                  {" "}
                  <Form.Label>
                    Direct Cost (%)<span className="require-star">*</span>
                  </Form.Label>
                  <div className="info_icon">
                    <div className="tooltip">
                      <FontAwesomeIcon icon={faCircleInfo} />
                      <span className="tooltiptext ">
                        All direct job cost(%) added up except labor cost of
                        goods, permits, sub contractors are a few examples.
                      </span>
                    </div>
                  </div>
                </div>

                <Form.Control
                  type="number"
                  name="variableCost"
                  value={variableCost}
                  onChange={handleVariableCostChange}
                  className={errors.variableCost ? "border-danger" : ""}
                  placeholder="Direct Cost (%)"
                />
                {errors.variableCost && (
                  <Form.Text className="text-danger">
                    {errors.variableCost}
                  </Form.Text>
                )}
              </Form.Group>
            </Card>
          </Col>
          <Col md={3}>
            <h5 className="mb-3">Revenue Amount (Yearly)</h5>
            <Card className="border-0 p-3 rounded">
              <Form.Group
                className="common_doller_class"
                controlId="variableCost"
              >
                <div className="d-flex align-items-center">
                  {" "}
                  <Form.Label>
                    Amount<span className="require-star">*</span>
                  </Form.Label>
                  <div className="info_icon">
                    <div className="tooltip">
                      <FontAwesomeIcon icon={faCircleInfo} />
                      <span className="tooltiptext tooltip_text1">
                        Total trailing 12 month or 1 year of total billed
                        revenue
                      </span>
                    </div>
                  </div>
                </div>
                <div className="input-group ">
                  <span className="input-group-text">$</span>
                  <Form.Control
                    type="text"
                    name="amount"
                    value={amount}
                    onChange={handleAmountChange}
                    className={errors.amount ? "border-danger" : ""}
                    placeholder="Amount"
                    maxLength="10"
                  />
                </div>
                {errors.amount && (
                  <Form.Text className="text-danger">{errors.amount}</Form.Text>
                )}
              </Form.Group>
            </Card>
          </Col>
        </Row>

        {/* Over Head */}
        <Row className="mb-3 common_doller_class">
          <Col md={12}>
            <h5 className="mb-3">Over Head</h5>
            <Card className="border-0 p-3 rounded">
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="overheadCosts">
                    <div className="d-flex align-items-center">
                      <Form.Label>Overhead Costs</Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Total 1 year time frame of Expenses on your P&L
                            minus and field labor cost office labor would be
                            included.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="input-group ">
                      <span className="input-group-text">$</span>
                      <Form.Control
                        type="text"
                        name="overheadCosts"
                        value={overheadCosts}
                        lang={navigator.language}
                        maxLength="20"
                        onChange={handleOverheadCostsChange}
                        className={errors.overheadCosts ? "border-danger" : ""}
                        placeholder="Enter Overhead Costs"
                      />
                    </div>
                    {errors.overheadCosts && (
                      <Form.Text className="text-danger">
                        {errors.overheadCosts}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="ownersPay">
                    <div className="d-flex align-items-center">
                      {" "}
                      <Form.Label>Owner's Pay</Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            All owners total yearly cash draws not including W2
                            that would be counted on overhead cost most likely
                            on balance sheet.{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Form.Control
                        type="text"
                        name="ownersPay"
                        value={ownersPay}
                        maxLength="10"
                        onChange={handleOwnersPayChange}
                        className={errors.ownersPay ? "border-danger" : ""}
                        placeholder="Enter Owner's Pay"
                      />
                    </div>
                    {errors.ownersPay && (
                      <Form.Text className="text-danger">
                        {errors.ownersPay}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="loans">
                    <div className="d-flex align-items-center">
                      <Form.Label>Loans</Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            All company loans total of all loan payments x 12
                            not pay off amounts do not include any loans that
                            may be on overhead cost most likely on balance
                            sheet.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Form.Control
                        type="text"
                        name="loans"
                        value={loans}
                        maxLength="10"
                        onChange={handleLoansChange}
                        className={errors.loans ? "border-danger" : ""}
                        placeholder="Enter Loans"
                      />
                    </div>
                    {errors.loans && (
                      <Form.Text className="text-danger">
                        {errors.loans}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="other">
                    <div className="d-flex align-items-center">
                      <Form.Label>Other</Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Any other cash flow items that come out of your
                            company total for 1 year cover all cash flow that is
                            not on overhead cost.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Form.Control
                        type="text"
                        name="other"
                        value={other}
                        maxLength="10"
                        onChange={handleOtherChange}
                        className={errors.other ? "border-danger" : ""}
                        placeholder="Enter Other Costs"
                      />
                    </div>
                    {errors.other && (
                      <Form.Text className="text-danger">
                        {errors.other}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row className="mb-3 labor_Costs">
          <Col md={12}>
            <h5 className="mb-3">Total </h5>
            <Card className="border-0 p-3 rounded">
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-lg-3" controlId="highPaid">
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Total of all expenses
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        {/* <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Any other cash flow items that come out of your
                            company total for 1 year cover all cash flow that is
                            not on overhead cost.
                          </span>
                        </div> */}
                      </div>
                    </div>
                    <div className="input-group common_doller_class">
                      <span className="input-group-text">$</span>
                      <Form.Control
                        type="text"
                        name="totalAmount"
                        value={totalAmount.toLocaleString()}
                        onChange={handleChange}
                        className={errors.totalAmount ? "border-danger" : ""}
                        placeholder="Enter $ Per Hour"
                        disabled
                      />
                    </div>
                    {errors.totalAmount && (
                      <Form.Text className="text-danger">
                        {errors.totalAmount}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        {/* Labor Costs */}
        <Row className="mb-3 labor_Costs">
          <Col md={12}>
            <h5 className="mb-3">Labor Costs</h5>
            <Card className="border-0 p-3 rounded">
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-lg-3" controlId="highPaid">
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        High Paid Per Dollar
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            High paid field labor as a average or your highest
                            paid. This will go towards job estimates
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="input-group common_doller_class">
                      <span className="input-group-text">$</span>
                      <Form.Control
                        type="text"
                        name="highPaid"
                        value={highPaid}
                        maxLength="10"
                        onChange={handleChange}
                        className={errors.highPaid ? "border-danger" : ""}
                        placeholder="Enter high paid per hour"
                      />
                    </div>
                    {errors.highPaid && (
                      <Form.Text className="text-danger">
                        {errors.highPaid}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group
                    className="mb-lg-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        High Paid Labor Burden (%)
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            If your payroll taxes and other behind the scene
                            labor cost are not in your overhead cost please
                            enter in as a percentage for high paid employees
                            this can also help figure in for inefficient labor
                            or overtime cost.
                          </span>
                        </div>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      name="highPaidburden"
                      value={highPaidburden}
                      onChange={handleChange}
                      maxLength="10"
                      className={
                        errors.highPaidburden
                          ? "border-danger mb-0 mt-lg-2"
                          : "mt-lg-2 mb-0 "
                      }
                      placeholder="Enter high paid labor burden"
                    />
                    {errors.highPaidburden && (
                      <Form.Text className="text-danger">
                        {errors.highPaidburden}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-lg-3" controlId="midPaid">
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Mid Paid Per Dollar
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Mid paid field labor as a average or your highest
                            paid. This will go towards job estimates
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="input-group common_doller_class">
                      <span className="input-group-text">$</span>
                      <Form.Control
                        type="text"
                        name="midPaid"
                        value={midPaid}
                        onChange={handleChange}
                        maxLength="10"
                        className={errors.midPaid ? "border-danger" : ""}
                        placeholder="Enter mid paid per dollar"
                      />
                    </div>
                    {errors.midPaid && (
                      <Form.Text className="text-danger">
                        {errors.midPaid}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group
                    className="mb-lg-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Mid Paid Labor Burden (%)
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext  tooltip_text1">
                            If your payroll taxes and other behind the scene
                            labor cost are not in your overhead cost please
                            enter in as a percentage for mid paid employees this
                            can also help figure in for inefficient labor or
                            overtime cost.{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      name="midPaidburden"
                      value={midPaidburden}
                      onChange={handleChange}
                      maxLength="10"
                      className={
                        errors.midPaid
                          ? "border-danger mb-0 mt-lg-2"
                          : " mb-0 mt-lg-2"
                      }
                      placeholder="Enter mid paid labor burden"
                    />
                    {errors.midPaidburden && (
                      <Form.Text className="text-danger">
                        {errors.midPaidburden}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-lg-3" controlId="lowPaid">
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Low Paid Per Dollar
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Low paid field labor as a average or your highest
                            paid. This will go towards job estimates
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="input-group common_doller_class">
                      <span className="input-group-text">$</span>
                      <Form.Control
                        type="text"
                        name="lowPaid"
                        value={lowPaid}
                        onChange={handleChange}
                        maxLength="10"
                        className={errors.lowPaid ? "border-danger" : ""}
                        placeholder="Enter low paid per dollar"
                      />
                    </div>
                    {errors.lowPaid && (
                      <Form.Text className="text-danger">
                        {errors.lowPaid}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  {" "}
                  <Form.Group
                    className="mb-lg-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Low Paid Labor Burden (%)
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            If your payroll taxes and other behind the scene
                            labor cost are not in your overhead cost please
                            enter in as a percentage for low paid employees.this
                            can also help figure in for inefficient labor or
                            overtime cost.{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      name="lowPaidburden"
                      value={lowPaidburden}
                      maxLength="10"
                      onChange={handleChange}
                      className={
                        errors.lowPaidburden
                          ? "border-danger mb-0 mt-lg-2"
                          : "mt-lg-2 mb-0"
                      }
                      placeholder="Enter low paid labor burden"
                    />
                    {errors.lowPaidburden && (
                      <Form.Text className="text-danger">
                        {errors.lowPaidburden}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        {/* Monthly Breakeven cost */}
        <Row className="mb-3 monthly_Breakeven_cost">
          <Col md={12}>
            <h5 className="mb-3">Monthly Breakeven cost </h5>
            <Card className="border-0 p-3 rounded">
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="breakevenHighPaid">
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        High Paid Hour Month
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Amount of hours each high paid field employee works
                            a month on average this helps figure in your break
                            evens average monthly hours are typically 173 - 174.{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      name="breakevenHighPaid"
                      value={breakevenHighPaid}
                      onChange={handleChange}
                      maxLength="10"
                      className={
                        errors.breakevenHighPaid
                          ? "border-danger mb-0 mt-lg-2"
                          : "mt-lg-2 mb-0"
                      }
                      placeholder="Enter high paid hour month"
                    />
                    {errors.breakevenHighPaid && (
                      <Form.Text className="text-danger">
                        {errors.breakevenHighPaid}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        High Paid People<span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Amount of High paid field employees you currently
                            have.{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      name="monthlyHighPaid"
                      value={monthlyHighPaid}
                      onChange={handleChange}
                      maxLength="10"
                      className={
                        errors.monthlyHighPaid
                          ? "border-danger mb-0 mt-lg-2"
                          : "mt-lg-2 mb-0"
                      }
                      placeholder="Enter high paid people"
                    />
                    {errors.monthlyHighPaid && (
                      <Form.Text className="text-danger">
                        {errors.monthlyHighPaid}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="breakevenMidPaid">
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Mid Paid Hour Month
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Amount of hours each mid paid field employee works a
                            month on average this helps figure in your break
                            evens average monthly hours are typically 173 - 174.{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      name="breakevenMidPaid"
                      value={breakevenMidPaid}
                      maxLength="10"
                      onChange={handleChange}
                      className={
                        errors.breakevenMidPaid
                          ? "border-danger mb-0 mt-lg-2"
                          : "mt-lg-2 mb-0"
                      }
                      placeholder="Enter mid paid hour month"
                    />
                    {errors.breakevenMidPaid && (
                      <Form.Text className="text-danger">
                        {errors.breakevenMidPaid}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Mid Paid People<span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext tooltip_text1">
                            Amount of mid paid field employees you currently
                            have.{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      name="monthlyMidPaid"
                      value={monthlyMidPaid}
                      maxLength="10"
                      onChange={handleChange}
                      className={
                        errors.monthlyMidPaid
                          ? "border-danger mb-0 mt-lg-2"
                          : "mt-lg-2 mb-0"
                      }
                      placeholder="Enter mid paid people"
                    />
                    {errors.monthlyHighPaid && (
                      <Form.Text className="text-danger">
                        {errors.monthlyHighPaid}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="breakevenLowPaid">
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Low Paid Hour Month
                        <span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Amount of hours each low paid field employee works a
                            month on average this helps figure in your break
                            evens average monthly hours are typically 173 - 174.{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      name="breakevenLowPaid"
                      value={breakevenLowPaid}
                      onChange={handleChange}
                      maxLength="10"
                      className={errors.breakevenLowPaid ? "border-danger" : ""}
                      placeholder="Enter low paid hour month"
                    />
                    {errors.breakevenLowPaid && (
                      <Form.Text className="text-danger">
                        {errors.breakevenLowPaid}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <div className="d-flex align-items-center">
                      <Form.Label>
                        Low Paid People<span className="require-star">*</span>
                      </Form.Label>
                      <div className="info_icon">
                        <div className="tooltip">
                          <FontAwesomeIcon icon={faCircleInfo} />
                          <span className="tooltiptext ">
                            Amount of low paid field employees you currently
                            have.{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Form.Control
                      type="text"
                      name="monthlyLowPaid"
                      value={monthlyLowPaid}
                      onChange={handleChange}
                      maxLength="10"
                      className={
                        errors.monthlyLowPaid
                          ? "border-danger mt-lg-0"
                          : "mt-lg-0"
                      }
                      placeholder="Enter low paid people"
                    />
                    {errors.monthlyLowPaid && (
                      <Form.Text className="text-danger">
                        {errors.monthlyLowPaid}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mb-5">
          <Button variant="success" className="px-5 mt-2" type="submit">
            {jobConfgs.id ? "Update" : "   Save"}
          </Button>
        </div>
      </Form>
    </Container>
  );
}
